(function($) {
    var $ = jQuery = $;

    // sparkling effect
    // https://codepen.io/renerehme/pen/XWjeNbY
    const vectorsForSpakrling = {
        default: ({
            size
        }) => `<svg class="disable-fill-color" width="${size}" height="${size}" viewBox="0 0 68 68" fill="none"><path d="M26.5 25.5C19.0043 33.3697 0 34 0 34C0 34 19.1013 35.3684 26.5 43.5C33.234 50.901 34 68 34 68C34 68 36.9884 50.7065 44.5 43.5C51.6431 36.647 68 34 68 34C68 34 51.6947 32.0939 44.5 25.5C36.5605 18.2235 34 0 34 0C34 0 33.6591 17.9837 26.5 25.5Z" fill="currentColor" /></svg>`,
        teddy: () => '<span>🐻</span>',
        pumpkin: () => '<span>🎃</span>',
        'christmas-tree': () => '<span>🎄</span>'
    };

    function random(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function initSparkling() {
        const color = "#FFC700";
        const svgPath = '';

        function sparkling() {
            $('.sparkling').each(function() {
                const sparklingElement = $(this);
                const stars = sparklingElement.find('.star');

                const isTouch = $('html').hasClass('touch');
                if ((isTouch && !sparklingElement.hasClass('sparkling-touch')) ||
                    (!isTouch && sparklingElement.hasClass('sparkling-touch'))) {
                    return;
                }

                if (stars.length > 5) {
                    stars.first().remove();
                }

                const vector = sparklingElement.attr('data-vector') || 'default';

                sparklingElement.append(addStar({
                    vector
                }));
            });

            setTimeout(sparkling, random(300, 1700));
        }

        function addStar({
            vector
        }) {
            const size = random(8, 15);
            const top = random(-50, 50);
            const left = random(0, 100);

            return `<span class="star" style="top:${top}%; left:${left}%;">${vectorsForSpakrling[vector] ? vectorsForSpakrling[vector]({ size }) : vectorsForSpakrling.default({ size })}</span>`;
        }

        sparkling();
    }

    $(function() {
        // init sparkling stars
        initSparkling();
    });

    function handlerSizechart() {
        if ($('.cc-accordion-item__panel table').length) {
            const sizes = ["taglia", "talla", "rozmiar", "maat", "größe", "size", "misurare", "maat"];

            if (
                sizes.includes($('#description .cc-accordion-item__panel table tr th').eq(0)?.html()?.toLowerCase()?.trim()) ||
                sizes.includes($('#description .cc-accordion-item__panel table tr th').eq(1)?.html()?.toLowerCase()?.trim())
            ) {

                $('#description .cc-accordion-item__panel table')
                    .clone()
                    .appendTo($('.original-size-chart'));

                // // this is for tabs
                // if ($('#size-guide .original-size-chart')) {
                //   $('#description .cc-accordion-item__panel table')
                //     .clone()
                //     .appendTo($('#size-guide .original-size-chart'));
                // }
            }
        } else {
            $('.size-chart-container.size-chart-from-description').remove();
        }
    }

    function handleRandomReiews() {
        const JSON_REVIEWS = [{
            "id": "Mh-BcVe_x",
            "name": "Natalia S.",
            "date": "24/08/2023",
            "rating": 5,
            "review": "Simply beautiful, very comfortable to wear even on hot summer days. Perfect for anyone who loves minimal style for kids. My boy loves it :)",
            "profile": "https://cdn.shopify.com/s/files/1/0612/5440/2296/files/349319183_768848768330487_8708459539240288267_n.jpg?v=1693261366",
            "product": {
                "name": "Mundo Enojona T-shirt | Ochre",
                "image": "https://cdn.shopify.com/s/files/1/0612/5440/2296/files/image_baf1456b-6170-4fdd-bebe-949b33589f70_x50.jpg?v=1690928457"
            }
        }, ];

        const randomReviewIndex = random(0, JSON_REVIEWS.length - 1);
        const randomReview = JSON_REVIEWS[randomReviewIndex];

        if (!randomReview) {
            return
        }

        $('.product-detail-randome-review').find('p.description').html(`<span>"${randomReview.review}"</span> - <span class="reviewer">${randomReview.name}</span> <a href="https://minimobebe.com/pages/reviews" target="_blank">See latest reviews</a>`);

        if (randomReview.profile) {
            const html = `<div class="profile-pic"><img src="${randomReview.profile}" title="" alt="reviwer" /></div>`;
            $('.product-detail-randome-review').append($(html))
        }
    }
  
    if ($('body').hasClass('template-product')) {
        handlerSizechart();

        if ($('.product-detail-randome-review')) {
            handleRandomReiews();
        }
    }

    // function trainUserToScrollProductImages() {
    //   const scroller = $('.products-grid-container > div:first-child .css-carousel');

    //   if (scroller.length > 0 && scroller.scrollLeft() === 0) {
    //     const scrollLeft = scroller.width() / 2;
    //     scroller
    //       .delay(2000).animate({ scrollLeft }, 100)
    //       .delay(2 * 100).animate({ scrollLeft: 0 }, 100)
    //       .delay(3 * 100).animate({ scrollLeft }, 100)
    //       .delay(4 * 100).animate({ scrollLeft: 0 }, 100);
    //   }
    // }

    // if ($('body').hasClass('template-collection')) {
    //   setTimeout(() => {
    //     trainUserToScrollProductImages();
    //   }, 0)
    // }
})(theme.jQuery);
// convert to es6 => https://babeljs.io/repl
// minify js file => https://www.toptal.com/developers/javascript-minifier